// src/modules/clinical-info/clinical-info.routes.js

import ClinicalInfoPageContainer from "./pages/ClinicalInfoPageContainer";
import DischargedPage from "./pages/discharged/DischargedPage";
import AdmittedPage from "./pages/admitted/AdmittedPage";
import EmergencyPage from "./pages/emergency/EmergencyPage";
// HighCostPage temporalmente reemplazada por HighCostMaintenancePage durante
// la ventana de optimización. Restaurar cuando el módulo vuelva online.
// import HighCostPage from "./pages/high-cost/HighCostPage";
import HighCostMaintenancePage from "./pages/high-cost/HighCostMaintenancePage";
import HighRiskPage from "./pages/high-risk/HighRiskPage";

/**
 * Routes configuration for the clinical-info module
 */
export const clinicalInfoRoutes = [
  {
    path: "/ClinicalInfo",
    element: <ClinicalInfoPageContainer />,
  },
  {
    path: "/clinical-info/discharged",
    element: <DischargedPage />,
  },
  {
    path: "/clinical-info/admitted",
    element: <AdmittedPage />,
  },
  {
    path: "/clinical-info/emergency",
    element: <EmergencyPage />,
  },
  {
    path: "/clinical-info/high-cost",
    element: <HighCostMaintenancePage />,
  },
  {
    path: "/clinical-info/high-risk",
    element: <HighRiskPage />,
  },
];

export default clinicalInfoRoutes;
